// extracted by mini-css-extract-plugin
export default {"root":"S7v1Ta","link":"x7Zma3"};